<div #header class="header-container">
  <div class="header-content">
    <ng-content select="[header-content]"></ng-content>
  </div>
</div>
<div [hidden]="!includeBanner" class="banner-container" #banner>
  <ng-content select="[banner-content]"></ng-content>
</div>
<div
  class="buffer"
  [ngClass]="{
    'mb-32px': !isSystemBanner && !(isMobile$ | async),
    'mb-24px': !isSystemBanner && (isMobile$ | async),
    'mb-48px': isSystemBanner && !(isMobile$ | async),
    'mb-40px': isSystemBanner && (isMobile$ | async)
  }"
  #buffer></div>
